module.exports = __webpack_public_path__ + "img/about-service-2.37af2c5d.jpg";